import { Event, EventStatus } from 'types/interfaces/Event'
import { MediaAssetType } from 'types/interfaces/MediaAsset'
import { getMediaTypeByEventStatus } from 'utils/events/utils'

export const getMediaAssetLocator = (event: Event) => {
  if (!event.mediaAssets) return null

  const mediaAssetType = getMediaTypeByEventStatus(event.status as EventStatus)

  const mediaAsset = event.mediaAssets.find(
    ({ assetType }: { assetType: MediaAssetType }) =>
      assetType === mediaAssetType
  )

  return mediaAsset?.mediaAssetLocators?.[0]
}

export const getMediaAssetLocators = (event: Event) => {
  if (!event.mediaAssets) return null

  const mediaAssetType = getMediaTypeByEventStatus(event.status as EventStatus)

  const mediaAsset = event.mediaAssets.find(
    ({ assetType }: { assetType: MediaAssetType }) =>
      assetType === mediaAssetType
  )

  return mediaAsset?.mediaAssetLocators || []
}

export const getSrcType = (url: string) => {
  return url.endsWith('.mp4') ? 'video/mp4' : 'application/x-mpegURL'
}
